module.exports = __webpack_public_path__ + "static/media/1.9f69d8f9.jpg";